import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import { Container, IconContainer, Content, Label, Value } from './styles';

const Props = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]),
  margin: PropTypes.string,
};

const DEFAULT_PROPS = {
  margin: '',
};

export default function PlanField({ margin, icon, label, value }) {
  return (
    <Container margin={margin}>
      <IconContainer>
        <Icon name={icon} />
      </IconContainer>
      <Content>
        <Label>{label}</Label>
        <Value>{value}</Value>
      </Content>
    </Container>
  );
}

PlanField.propTypes = Props;
PlanField.defaultProps = DEFAULT_PROPS;
